"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _contents = require("../utils/contents");

var _actions = require("../actions");

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var initialState = {
  // raw data
  topics: null,
  folders: null,
  publications: null,
  // indexes
  foldersIndex: null,
  videosIndex: null,
  contentIndex: null,
  // assets
  currentAsset: null,
  currentLocalAsset: null,
  assetMap: {},
  localAssetMap: {},
  heroShotMap: {},
  imageMaps: null,
  imageMapBlobs: null,
  // content download for offline use
  fetchingContentBundle: false,
  contentBundleProgress: null,
  contentBundleError: null,
  // loading indicators
  fetching: false,
  fetchingAsset: false,
  fetchingLocalAsset: false,
  fetchingImageMaps: false,
  fetchingUpdates: false,
  // errors
  error: null,
  errorAsset: null,
  errorLocalAsset: null,
  errorImageMap: null,
  errorSearch: null,
  errorUpdates: null,
  // search state
  searchQuery: "",
  searchTopics: null,
  searchFolders: null,
  // navigation
  currentFolder: null,
  // offline content updates
  updatesAvailable: false
};

function contents() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actions.FLUSH_CONTENTS:
      state.imageMapBlobs && Object.entries(state.imageMapBlobs).map(function (x) {
        return (0, _contents.freeBlobResource)(x);
      }); // TODO: side effect in reducer, not good

      return _objectSpread({}, state, {
        topics: null,
        folders: null,
        publications: null,
        imageMapBlobs: null,
        imageMaps: null,
        currentFolder: null,
        error: null,
        searchQuery: "",
        searchTopics: null,
        searchFolders: null,
        localAssetMap: {},
        assetMap: {},
        updatesAvailable: false
      });

    case _actions.GET_CONTENTS_REQUEST:
      return _objectSpread({}, state, {
        topics: null,
        fetching: true,
        error: null
      });

    case _actions.GET_CONTENTS_ERROR:
      return _objectSpread({}, state, {
        topics: null,
        fetching: false,
        error: action.payload
      });

    case _actions.GET_CONTENTS_SUCCESS:
      return (0, _contents.processLoadedContent)(state, action.payload);

    case _actions.GET_CONTENTS_DOWNLOAD_REQUEST:
      return _objectSpread({}, state, {
        contentBundleProgress: null,
        fetchingContentBundle: true,
        contentBundleError: null
      });

    case _actions.GET_CONTENTS_DOWNLOAD_SUCCESS:
      return _objectSpread({}, state, {
        contentBundleProgress: null,
        fetchingContentBundle: false,
        contentBundleError: null
      });

    case _actions.GET_CONTENTS_DOWNLOAD_PROGRESS:
      return _objectSpread({}, state, {
        contentBundleProgress: action.payload
      });

    case _actions.GET_CONTENTS_DOWNLOAD_ERROR:
      return _objectSpread({}, state, {
        contentBundleProgress: null,
        fetchingContentBundle: false,
        contentBundleError: action.payload
      });

    case _actions.SEARCH_CONTENTS_REQUEST:
      return _objectSpread({}, state, {
        fetching: true,
        errorSearch: null
      });

    case _actions.SEARCH_CONTENTS_ERROR:
      return _objectSpread({}, state, {
        fetching: false,
        errorSearch: action.payload
      });

    case _actions.SEARCH_CONTENTS_CANCEL:
      return _objectSpread({}, state, {
        fetching: false,
        errorSearch: null
      });

    case _actions.SEARCH_CONTENTS_SUCCESS:
      return (0, _contents.processLoadedSearchContent)(state, action.payload);

    case _actions.GET_IMAGE_MAPS_REQUEST:
      return _objectSpread({}, state, {
        fetchingImageMaps: true,
        imageMapBlobs: null
      });

    case _actions.GET_IMAGE_MAPS_SUCCESS:
      return _objectSpread({}, state, {
        fetchingImageMaps: false,
        imageMapBlobs: action.payload
      });

    case _actions.GET_IMAGE_MAPS_ERROR:
      return _objectSpread({}, state, {
        fetchingImageMaps: false,
        errorImageMap: action.payload
      });

    case _actions.GET_ASSET_REQUEST:
      return _objectSpread({}, state, {
        currentAsset: null,
        fetchingAsset: true,
        errorAsset: null
      });

    case _actions.GET_ASSET_SUCCESS:
      return _objectSpread({}, state, {
        currentAsset: action.payload,
        assetMap: _objectSpread({}, state.assetMap, _defineProperty({}, action.payload.objectKey, action.payload)),
        fetchingAsset: false,
        errorAsset: null
      });

    case _actions.GET_ASSET_ERROR:
      return _objectSpread({}, state, {
        currentAsset: null,
        fetchingAsset: false,
        errorAsset: action.payload
      });

    case _actions.GET_LOCAL_ASSET_REQUEST:
      return _objectSpread({}, state, {
        currentLocalAsset: null,
        fetchingLocalAsset: true,
        errorLocalAsset: null
      });

    case _actions.GET_LOCAL_ASSET_SUCCESS:
      return _objectSpread({}, state, {
        currentLocalAsset: action.payload,
        localAssetMap: _objectSpread({}, state.localAssetMap, _defineProperty({}, action.payload.objectKey, action.payload)),
        fetchingLocalAsset: false,
        errorLocalAsset: null
      });

    case _actions.GET_LOCAL_ASSET_ERROR:
      return _objectSpread({}, state, {
        currentLocalAsset: null,
        fetchingLocalAsset: false,
        errorLocalAsset: action.payload
      });

    case _actions.GET_FILE_REQUEST:
      return _objectSpread({}, state, {
        currentFile: null,
        fetchingFile: true,
        errorFile: null
      });

    case _actions.GET_FILE_SUCCESS:
      return _objectSpread({}, state, {
        currentFile: action.payload,
        fetchingFile: false,
        errorFile: null
      });

    case _actions.GET_FILE_ERROR:
      return _objectSpread({}, state, {
        currentFile: null,
        fetchingFile: false,
        errorFile: action.payload
      });

    case _actions.GET_HEROSHOT_REQUEST:
      return _objectSpread({}, state, {
        fetchingHeroShot: true,
        errorHeroShot: null
      });

    case _actions.GET_HEROSHOT_SUCCESS:
      return _objectSpread({}, state, {
        heroShotMap: _objectSpread({}, state.heroShotMap, _defineProperty({}, action.payload.key, action.payload.url)),
        fetchingHeroShot: false,
        errorHeroShot: null
      });

    case _actions.GET_HEROSHOT_ERROR:
      return _objectSpread({}, state, {
        fetchingHeroShot: false,
        errorHeroShot: action.payload
      });

    case _actions.SET_SEARCH_QUERY:
      return _objectSpread({}, state, {
        searchQuery: action.payload,
        currentFolder: null,
        errorSearch: null
      });

    case _actions.CHECK_UPDATES_REQUEST:
      return _objectSpread({}, state, {
        fetchingUpdates: true,
        updatesAvailable: false
      });

    case _actions.CHECK_UPDATES_SUCCESS:
      return _objectSpread({}, state, {
        fetchingUpdates: false,
        updatesAvailable: (0, _contents.isUpdateAvailable)(state.publications.toJS(), action.payload.publications)
      });

    case _actions.CHECK_UPDATES_ERROR:
      return _objectSpread({}, state, {
        fetchingUpdates: false,
        updatesAvailable: false,
        errorUpdates: action.payload
      });

    default:
      return state;
  }
}

var _default = contents;
exports.default = _default;